import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from '@app/core/access-control/services/users/users.service';
import { IRulesPassword } from '@app/shared/interfaces/users.interface';
import Utils from '@app/shared/utils/utils';
import { ToastrService } from 'ngx-toastr';

export const rulesItems: IRulesPassword[] = [
  {
    ruleEspecify: 'minLength',
    displayMessage: 'mínimo 8 caracteres;',
    activeError: false,
  },
  {
    ruleEspecify: 'uppercaseLowercase',
    displayMessage: 'uma letra maiúscula e uma minúscula;',
    activeError: false,
  },
  {
    ruleEspecify: 'digit',
    displayMessage: 'um número;',
    activeError: false,
  },
  {
    ruleEspecify: 'specialChar',
    displayMessage: 'um caracter especial (#, @, %...);',
    activeError: false,
  },
];

enum RulePosition {
  DIGIT = rulesItems.findIndex((i) => i.ruleEspecify === 'digit'),
  MINLENGTH = rulesItems.findIndex((i) => i.ruleEspecify === 'minLength'),
  UPPERLOWER = rulesItems.findIndex((i) => i.ruleEspecify === 'uppercaseLowercase'),
  SPECIALCHAR = rulesItems.findIndex((i) => i.ruleEspecify === 'specialChar'),
}

@Component({
  selector: 'app-resetpass',
  templateUrl: './resetpass.component.html',
  styleUrls: ['./resetpass.component.sass'],
})
export class ResetPassComponent implements OnInit {
  form!: FormGroup;
  eyePass = true;
  eyePassConfirm = true;
  confirmPasswordError = false;
  data: any;
  rules: IRulesPassword[] | any = rulesItems;

  constructor(
    private fb: FormBuilder,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private userService: UsersService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group(
      {
        Id: ['', []],
        newPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
      },
      { validators: this.passwordMatchValidator }
    );

    this.activatedRouter.queryParams.subscribe({
      next: ({ Id }: any) => {
        this.form.get('Id')?.setValue(Id);
        if (!Id) {
          this.router.navigate(['/login']);
        }
      },
    });
  }

  getValidationErrorMessage(groupNewPass: any): void {
    const value = groupNewPass.value;
    this.rules.at(RulePosition.SPECIALCHAR).activeError = !Utils.hasSpecialChar(value);
    this.rules.at(RulePosition.UPPERLOWER).activeError = !Utils.hasUpperCaseAndLowerCase(value);
    this.rules.at(RulePosition.DIGIT).activeError = !Utils.hasNumber(value);
    this.rules.at(RulePosition.MINLENGTH).activeError = value.length < 8;
  }

  isDisabled(): boolean {
    const { confirmPassword, newPassword } = this.form.value;
    const hasActiveError = this.rules.some((r: IRulesPassword) => r.activeError);
    const hasMismatchedPasswords = confirmPassword !== newPassword;

    return hasActiveError || hasMismatchedPasswords;
  }

  passwordMatchValidator(formGroup: FormGroup): null | any {
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;

    if (newPassword === confirmPassword) {
      formGroup.get('confirmPassword')?.setErrors(null);
      return null;
    } else {
      formGroup.get('confirmPassword')?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    }
  }

  resetPass(data: any): void {
    this.userService.resetUserPassword(data).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.toastr.success('Senha de acesso atualizada com sucesso.');
          this.router.navigate(['/login']);
        }
      },
      error: (err: any) => {
        this.toastr.error(err.errors);
      },
      complete: () => {
        this.form.reset();
      }
    });
  }
}
